import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({

    rootGrid: {
        minHeight: '75vh',
    },

    card: {
        padding: '30px',
    },

    title: {
        padding: '20px 0px',
    },

    subtitle: {
        paddingBottom: '20px',
    },

    textField: {
        paddingBottom: '20px',
    },

    button: {
        paddingBottom: '20px',
    },

}));

export default useStyles;
